<template>
    <div class="DulizhanReconciliation-container">
        <div class="select-box">
            <div class="select-item">
                <div class="label">开始日期：</div>
                <el-date-picker
                    v-model="startTime"
                    type="date"
                    placeholder="选择日期"
                    style="width: 180px"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"></el-date-picker>
            </div>
            <div class="select-item">
                <div class="label">结束日期：</div>
                <el-date-picker
                    v-model="endTime"
                    type="date"
                    style="width: 180px"
                    placeholder="选择日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"></el-date-picker>
            </div>
            <div class="select-item">
                <div class="label">公司：</div>
                <el-input placeholder="请输入公司" v-model="companyName" clearable></el-input>
            </div>
            <div class="select-item">
                <div class="label">店铺：</div>
                <el-input placeholder="请输入店铺" v-model="storeName" clearable></el-input>
            </div>
            <div class="select-item">
                <div class="label">订单号：</div>
                <el-input placeholder="请输入订单号" v-model="amazonOrderId" clearable></el-input>
            </div>
            <div class="select-item">
                <el-button type="primary" @click="handleQuery">查询</el-button>
            </div>
            <div class="select-item">
                <div class="label">交易一览状态：</div>
                <el-select v-model="transactionStatus" placeholder="请选择" clearable style="width: 180px"
                    @change="handleStatusChange">
                    <el-option label="不匹配" value="0"></el-option>
                    <el-option label="已匹配" value="1"></el-option>
                </el-select>
            </div>
        </div>
        <el-table
            :data="tableData"
            border
            stripe
            style="width: 100%"
            height="660"
            v-loading="loading">
            <el-table-column prop="purchaseDate" label="日期" width="100" align="center"></el-table-column>
            <el-table-column prop="orderId" label="订单ID" fixed width="120" align="center"></el-table-column>
            <!-- <el-table-column width="200" label="系统SKU:SKU别名" align="center">
                <template slot-scope="scope">
                    <el-popover placement="top" trigger="click">
                        <div v-if="scope.row.orderItems && scope.row.orderItems.length">
                            <div v-for="(item, index) in scope.row.orderItems" :key="index + 'a'">
                                <p style="margin-bottom: 5px;text-align: left;"><strong>系统SKU：</strong>{{
                                    item.variantSku || '-' }}</p>
                                <p style="margin-bottom: 5px;text-align: left;"><strong>SKU别名：</strong>{{ item.sellerSKU
                                    || '-' }}</p>
                            </div>
                        </div>
                        <el-button type="primary" size="small" slot="reference">查看SKU</el-button>
                    </el-popover>
                </template>
            </el-table-column> -->
            <el-table-column prop="adSpendAmount" label="平均广告花费金额($)" width="80" align="center"></el-table-column>
            <el-table-column prop="salesAmount" label="销售额($)" align="center"></el-table-column>
            <el-table-column prop="salesAmountChinese" label="销售额(￥)" align="center"></el-table-column>
            <el-table-column prop="receivedAmount" label="到账金额($)" align="center"></el-table-column>
            <el-table-column prop="receivedAmountChinese" label="到账金额(￥)" align="center"></el-table-column>
            <el-table-column prop="cpr" label="CPR($)" align="center"></el-table-column>
            <el-table-column prop="roi" label="ROI" align="center"></el-table-column>
            <el-table-column prop="logisticsCost" label="物流费(￥)" align="center"></el-table-column>
            <el-table-column prop="purchaseCost" label="采购费用(￥)" align="center"></el-table-column>
            <el-table-column prop="sharedFee" label="公摊费(￥)" align="center"></el-table-column>
            <el-table-column prop="handlingFee" label="手续费(￥)" align="center"></el-table-column>
            <el-table-column prop="platformCost" label="平台费(￥)" align="center"></el-table-column>
            <el-table-column prop="afterSalesFee" label="平台售后(￥)" align="center"></el-table-column>
            <el-table-column prop="platformFee" label="平台手续费(￥)" align="center"></el-table-column>
            <el-table-column align="center">
                <template slot="header">
                    库存匹配费用
                    <!-- <el-popover trigger="hover" placement="top">
            <p>收件费用、退件费用、分装费用、合装费用、包材费用、仓储费用、提现费用</p>
            <i class="iconfont icon-tishi" slot="reference"></i>
            </el-popover> -->
                </template>
                <template slot-scope="scope">
                    <span>{{ scope.row.warehouseCost }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="monthlyRentAmount" label="月租(￥)" align="center"></el-table-column> -->
            <el-table-column prop="paypalRefund" label="paypal退款(￥)" align="center"></el-table-column>
            <el-table-column prop="paypalDispute" label="paypal争议(￥)" align="center"></el-table-column>
            <el-table-column prop="paypalDisputeHandlingFee" label="paypal争议手续费(￥)" align="center"></el-table-column>
            <el-table-column prop="creditCardRefund" label="信用卡退款(￥)" align="center"></el-table-column>
            <el-table-column prop="creditCardChargeback" label="信用卡拒付(￥)" align="center"></el-table-column>
            <el-table-column prop="creditCardChargebackHandlingFee" label="信用卡拒付手续费(￥)"
                align="center"></el-table-column>
            <el-table-column prop="profit" label="盈利(￥)" align="center"></el-table-column>
            <el-table-column prop="profitPercentage" label="利润百分比" align="center"></el-table-column>
            <el-table-column prop="shopName" label="店铺" align="center" width="180"></el-table-column>
            <!-- <el-table-column prop="people" label="人员" align="center"></el-table-column> -->
            <el-table-column prop="payChannelDealIds" label="支付信息id" align="center" width="160"></el-table-column>
            <el-table-column prop="amazonOrderId" label="订单号" align="center" width="160"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pagination">
            <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-sizes="[10, 20, 50, 100, 1000, 2000]"
                :page-size="pageSize"
                :current-page="currentPage"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { ajaxGet, ajaxPost, Baseurl } from '@/api/api/api.js';
import { getTableHeader, formatDate } from '@/assets/js/common.js'
export default {
    name: 'DulizhanReconciliation',
    components: {},
    props: {},
    data() {
        return {
            startTime: '',
            endTime: '',
            storeName: '',
            companyName: '',
            amazonOrderId: '',
            tableData: [],
            historyData: [],
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            transactionTypeMap: {
                "Shipment": "订单发货",
                "Refund": "退款",
                "ProductAdsPayment": "广告费支出",
                "Adjustment": "调整",
                "Transfer": "转账/提款",
                "ServiceFee": "服务费",
                "SubscriptionFee": "订阅费",
                "CouponRedemption": "优惠券兑换",
                "DealFee": "Deal 费用",
                "LightningDealFee": "秒杀费用",
                "Reserve": "预留金",
                "FreeReplacementReturnCredits": "免费替换退货积分",
                "Other": "其他"
            },
            accountTypeMap: {
                "Standard Orders": "标准订单",
                "Invoiced Orders": "发票支付订单"
            },
            transactionStatusMap: {
                "RELEASED": "已结算",
                "DEFERRED": "已延期",
                "DEFERRED_RELEASED": "延期后释放"
            },
            dialogVisible: false,
            paymentDetails: {},
            dialogData: [],
            transactionStatus: '',
            paymentCycleStatus: '',
        };
    },
    created() { 
        const date = new Date();
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        this.endTime = `${year}-${month}-${day}`;
        if(month == '01'){
            this.startTime = `${year - 1}-12-31`;
        }else{
            this.startTime = `${year}-${(+month - 1).toString().padStart(2, '0')}-${day}`;
        }
        this.handleQuery();
    },
    mounted() { 
        
    },
    watch: {},
    computed: {},
    methods: {
        handleStatusChange(){
            const data = this.historyData.filter(item => {
                let transactionStatusMatch = true;
                let paymentCycleStatusMatch = true;
                if(this.transactionStatus !== ''){
                    transactionStatusMatch = item.transactionStatus == this.transactionStatus;
                }
                if(this.paymentCycleStatus !== ''){
                    paymentCycleStatusMatch = item.paymentStatus == this.paymentCycleStatus;
                }
                return transactionStatusMatch && paymentCycleStatusMatch;
            });
            this.tableData = data;
        },
        handleQuery(){
            this.loading = true;
            const params = {
                startTime: this.startTime ? this.startTime + ' 00:00:00' : '',
                endTime: this.endTime ? this.endTime + ' 23:59:59' : '',
                shopName: this.storeName,
                companyName: this.companyName,
                amazonOrderId: this.amazonOrderId,
                pageSize: this.pageSize,
                pageNum: this.currentPage
            };
            ajaxPost(
                Baseurl + 'orderPerformanceController/list', params
            ).then((res) => {
                const data = res.data;
                this.loading = false;
                const tableData = data.data.list;
                const paymentsMap = data.data.payments;
                for(let i = 0; i < tableData.length; i++){
                    const item = tableData[i];
                    if(item.transactions && item.transactions.length > 0){
                        let totalAmount = 0;
                        for(let j = 0; j < item.transactions.length; j++){
                            const transaction = item.transactions[j];
                            totalAmount += transaction.totalAmount;
                        }
                        item.transactionsTotalAmount = (+totalAmount).toFixed(2);
                        item.transactionsDifference = (item.orderActualCharge - +totalAmount).toFixed(2);
                        if(item.transactionsDifference == 0){
                            item.transactionStatus = '1';
                        }else{
                            item.transactionStatus = '0';
                        }
                    }else{
                        item.transactionStatus = '0';
                    }
                    if (item.transactionsOther && item.transactionsOther.length > 0) {
                        item.transactionsOther = item.transactionsOther.filter(item1 => item1.transactionStatus == 'DEFERRED_RELEASED');
                        let totalAmount = 0;
                        for (let j = 0; j < item.transactionsOther.length; j++) {
                            const transaction = item.transactionsOther[j];
                            totalAmount += transaction.totalAmount;
                        }
                        item.transactionsTotalAmountOther = (+totalAmount).toFixed(2);
                        item.transactionsDifferenceOther = (item.orderActualCharge - +totalAmount).toFixed(2);
                        // if (item.transactionsDifference == 0) {
                        //     item.transactionStatus = '1';
                        // } else {
                        //     item.transactionStatus = '0';
                        // }
                    } else {
                        // item.transactionStatus = '0';
                    }
                    let payments = [];
                    let paymentSuccessCount = 0;
                    const financialEventGroupId = item.financialEventGroupId;
                    if(financialEventGroupId){
                        payments = financialEventGroupId.split(',').map(item1 => {
                            const item111 = paymentsMap[item1] || {};
                            for(let j = 0; j < item.incomeExpenditureDetails.length; j++){
                                if(item111['originalTotal'] == item.incomeExpenditureDetails[j].amount){
                                    item111['paymentStatus'] = true;
                                    paymentSuccessCount ++;
                                    break;
                                }
                            }
                            return item111;
                        });
                    }
                    if(paymentSuccessCount == payments.length && payments.length > 0){
                        item.paymentStatus = '1';
                    }else{
                        item.paymentStatus = '0';
                    }
                    item.payments = payments;
                }
                this.tableData = tableData;
                this.historyData = JSON.parse(JSON.stringify(tableData));
                this.total = data.data.total;
            })
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.handleQuery();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.handleQuery();
        },
        getTransactionsBy(row) {
            const financialEventGroupId = row.financialEventGroupId;
            if(financialEventGroupId){
                ajaxPost(
                    Baseurl + 'amazonSettlement/getTransactionsByGroupId', { financialEventGroupId: financialEventGroupId }
                ).then((res) => {
                    const data = res.data;
                    if(data.code == 200){
                        this.paymentDetails = data.data;
                        this.dialogData = row.payments;
                        this.dialogVisible = true;
                    }else{
                        this.$message.warning('获取付款周期明细失败');
                    }
                })
            }else{
                this.$message.warning('该订单没有付款周期数据');
            }
        }
    },
};
</script>
<style lang="scss" scoped>
// 美化一下css
.DulizhanReconciliation-container{
    .select-box{
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 20px;
        .select-item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            margin-bottom: 10px;
            .label{
                width: 100px;
                text-align: right;
                margin-right: 10px;
                white-space: nowrap;
            }
        }
    }
    .table-box{
        margin-bottom: 20px;
    }
    .pagination{
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }
}
.text-fukuan {
    font-weight: bold;
    &.text-success {
        color: green;
    }
    &.text-danger {
        color: red;
    }
}
/deep/ .el-table .cell .el-button{
    padding-left: 0;
}
/deep/ .dialog-item{
    margin-bottom: 20px;
    .dialog-txt{
        font-weight: bold;
        margin-bottom: 5px;
    }
}
</style>